import React from 'react'

const Dashboard11 = () => {
  return (
    <h1>Dashboard11</h1>
  )
}

export default Dashboard11